import { type ProgramType } from './Program.types';
import { getProgramConfigValue } from './Program';

export function getSupportEmailAddress(programType: ProgramType, username?: string): string {
    const resolvedUsername =
        username ?? getProgramConfigValue<string>(programType, 'supportEmailUsername') ?? 'support';
    const domain = getProgramConfigValue<string>(programType, 'supportEmailDomain');
    return `${resolvedUsername}@${domain}`;
}
